import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import InputText from "../../components/InputText.jsx";
import TranslationText from "../../components/Translation/TranslationText.jsx";
import { RegistrationButtons } from "./RegistrationButtons.jsx";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import fetcherApi from '../../components/FetcherApi.jsx';
import urlTools from "../../tools/urlTools.jsx";
import EmailAndPhoneValidator from "../../components/EmailAndPhoneValidator.jsx";
import LegalEntityFunctions from "../../components/LegalEntityFunctions";
import validator from "../../components/FieldValidator.jsx";
import * as constants from "../../constants/constants";

class EmailVerificationRegistration extends Component {
	state = {
		email: "",
		error: false,
		errorText: "",
		isProcessing: false,
		confirmed: false,
		beginRecaptchaValidation: undefined
	};

	onChange = e => {
		e.value = validator.blockSpaceSymbol(e.value);
		this.setState({
			email: e.value,
			error: false,
			errorText: '',
			beginRecaptchaValidation: undefined
		});
	};

	beginRecaptchaValidation = () => {
		if (this.state.confirmed) {
			return;
		}

		this.setState((prevState) => ({
			beginRecaptchaValidation: !prevState.beginRecaptchaValidation
		}));
	}

	completeRecaptchaValidation = (recaptchaToken) => {
		this.setState({ isProcessing: false }, () => {
			this.confirm(recaptchaToken);
		});
	}

	confirm = async (recaptchaToken) => {
		if (this.state.confirmed) {
			return;
		}

		this.setState({ isProcessing: true });

		const emailStructureError = EmailAndPhoneValidator.getEmailStructureError(this.state.email);
		if (emailStructureError) {
			this.setState({
				error: true,
				errorText: emailStructureError,
				isProcessing: false,
				beginRecaptchaValidation: undefined
			});
			return;
		}

		const requestSettings = { recaptchaToken };
		const url = urlTools.constructRoute('api/RegistrationCode/send-code-virtual/' + LegalEntityFunctions.getLegalEntityId(localStorage.getItem(constants.SELECTED_COUNTRY)) + '/' + this.state.email);

		const httpResponse = await fetcherApi.post(url, null, requestSettings);
		const result = httpResponse.response;

		if (result.data.success) {
			this.setState({ confirmed: true, isProcessing: false });
		}
		else {
			if (result.data.error === "verification_resend_limit_reached") {
				this.setState({ error: true, errorText: "create_new_account_page_email_limit_error" });
			} else if (result.data.error === "email_incorrect_format") {
				this.setState({ error: true, errorText: "account_found_but_no_email_page_in_login_empty_email_field_error" });
			} else if (result.data.error === "email_placeholer") {
				this.setState({ error: true, errorText: "account_found_but_no_email_page_incorrect_email_error" });
			} else {
				this.setState({ error: true, errorText: result.data.error });
			}
			this.setState({ 
				isProcessing: false,
				beginRecaptchaValidation: undefined
			});
		}
	}

	render() {
		const { confirmed } = this.state;

		if (confirmed) {
			return (
				<Redirect to={{
					pathname: '/VerificationCodeRegistrationB2C',
					state: {
						codeSentTo: this.state.email,
						previousPath: this.props.location.pathname
					}
				}} />
			);
		}

		return (
			<React.Fragment>
				{!confirmed ? (
					<p><TranslationText text='create_new_my_rimi_account_page_info' /></p>
				) : null}
				<div className="form-group">
					<div className="form-row">
						<div className={!this.state.errorText ? "form-field" : "form-field -has-error"}>
							<label htmlFor="email" className="form-field__label">
								<TranslationText text='email_field_label' />
							</label>
							<InputText
								onChange={this.onChange}
								prop="email"
								value={this.state.email}
								className="form-field__input"
								placeholder="example@gmail.com"
							/>
						</div>
					</div>
					<div className="form-row">
						<div className="sublabel error-msg show">
							<span>{<TranslationText text={this.state.errorText} />}</span>
						</div>
					</div>
				</div>
				{
					this.state.beginRecaptchaValidation !== undefined
						? <GoogleReCaptcha onVerify={this.completeRecaptchaValidation} refreshReCaptcha={this.state.beginRecaptchaValidation} />
						: null
				}
				<RegistrationButtons
					isDisplayed={!this.state.confirmed}
					error={this.state.error}
					onBeginRecaptchaValidation={this.beginRecaptchaValidation}
					isProcessing={this.state.isProcessing}
					beginRecaptchaValidationState={this.state.beginRecaptchaValidation}
				/>
			</React.Fragment>
		);
	}
}

export default EmailVerificationRegistration; 